import AlarmIcon from '../assets/icons/alarm.svg?react';
import ChannelsIcon from '../assets/icons/channels.svg?react';
import MachineIcon from '../assets/icons/machine.svg?react';
import NotificationIcon from '../assets/icons/notification.svg?react';
import SwapVertIcon from '../assets/icons/swap_vert.svg?react';
import { useMobileSidebar } from '../contexts/MobileSidebarContext';
import { IS_DEMO } from '../demo/demoMode';
import { useLayoutTier } from '../hooks/useLayoutTier';
import { cn } from '../utils/className';
import { NavigationItem } from './NavigationItem';

export function Navigation() {
  const { close } = useMobileSidebar();
  const { isTabletDown } = useLayoutTier();

  return (
    <nav>
      <ul className={cn(isTabletDown && 'space-y-1 px-3 pt-3')}>
        <NavigationItem
          route='/machines'
          title='Machines'
          icon={<MachineIcon />}
          onClick={close}
        />
        {/* The demo shows the machine pages only. */}
        {!IS_DEMO && (
          <>
            <NavigationItem
              route='/alarms'
              title='Pulse alerts'
              icon={<AlarmIcon />}
              onClick={close}
            />
            <NavigationItem
              route='/channels'
              title='Channels'
              icon={<ChannelsIcon />}
              onClick={close}
            />
            <NavigationItem
              route='/notification-history'
              title='Notifications'
              icon={<NotificationIcon />}
              onClick={close}
            />
            <NavigationItem
              route='/edms-explorer'
              title='EDMS API'
              icon={<SwapVertIcon />}
              onClick={close}
            />
          </>
        )}
      </ul>
    </nav>
  );
}
